import { createSlice } from "@reduxjs/toolkit";
import { logout } from "./login.reducer";
const initialState = {
  editMode: false,
  saveStatus: null,
  editModeForAudit: false,
  filesUploadedIds: {},
  loading: false,
  noteModalOpen: false,
  noteData: {},
  settingsModalOpen: false,
  fileUploadStatus: 0, // this means nothing is happening
};

const miscSlice = createSlice({
  name: "misc",
  initialState,
  reducers: {
    toggleEditMode: (state, action) => {
      state.editMode = !state.editMode;
    },

    setSaveStatus: (state, action) => {
      state.saveStatus = action.payload;
    },
    toggleEditModeForAudit: (state, action) => {
      state.editModeForAudit = action.payload;
    },
    setFilesUploadedIds: (state, action) => {
      state.filesUploadedIds = action.payload;
    },
    loading: (state, action) => {
      state.loading = action.payload;
    },
    setNoteModalStatus: (state, action) => {
      state.noteModalOpen = action.payload;
    },
    setNoteData: (state, action) => {
      state.noteData = action.payload;
    },
    setSettingsModalStatus: (state, action) => {
      state.settingsModalOpen = action.payload;
    },
    setFileUploadStatus: (state, action) => {
      state.fileUploadStatus = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const {
  toggleEditMode,
  toggleEditModeForAudit,
  setSaveStatus,
  setFilesUploadedIds,
  loading,
  setNoteModalStatus,
  setNoteData,
  setSettingsModalStatus,
  setFileUploadStatus,
} = miscSlice.actions;

export default miscSlice.reducer;
